import React from "react";
import { Props_SnippetSpacer } from "./Spacer.props";

export const SnippetSpacer = (props: Props_SnippetSpacer) => {
    const { spacerProps } = props;
    const { mobileHeight, desktopHeight, backgroundColor } = spacerProps;


  const snippetClass = `snippet-spacer snippet-spacer--mobile-${mobileHeight?.value} snippet-spacer--desktop-${desktopHeight?.value}`;

  return (
    <div
      className={snippetClass}
      style={{
        backgroundColor: backgroundColor?.value ?? "transparent",
      }}
      role="presentation"
    ></div>
  );
};
